import { domToPng } from 'modern-screenshot'
import { isReactNativeIos } from '@mobi/web-native-comms/web'

export async function createImageBlobFromHtml(el: HTMLElement): Promise<Blob> {
  const base64Image = await createImageBase64FromHtml(el)
  const base64Response = await fetch(base64Image)
  const newBlob = await base64Response.blob()
  if (!newBlob) throw Error('Unable to create share')
  return newBlob
}

export async function createImageBase64FromHtml(el: HTMLElement): Promise<string> {
  const { width } = el.getBoundingClientRect()
  const pngBase64 = await domToPng(el, {
    scale: 2,
    width,
    onCloneEachNode: node => {
      if (isReactNativeIos) return
      // FIX for https://github.com/qq15725/modern-screenshot/issues/104
      // Remove once package is upgraded with issue resolved
      if (node instanceof HTMLElement) {
        node.style.fontSize = node.style.fontSize.replace(
          /(\d+(\.\d+)?(e[+-]?\d+)?)/g,
          (match, number) => {
            const parsedNumber = parseFloat(number)
            return isNaN(parsedNumber) ? match : (parsedNumber * 0.999).toString()
          }
        )
      }
    },
  })
  if (!pngBase64) throw Error('Unable to create share')
  return pngBase64
}
